"use client";

import { GroupSidebar } from "@/components/GroupSidebar";

export default function BegivenhederLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-950">
      <div className="max-w-[1400px] mx-auto flex gap-4 px-4 py-4">
        <div className="hidden lg:block w-72 shrink-0">
          <div className="sticky top-[4.5rem]">
            <GroupSidebar />
          </div>
        </div>

        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}
